// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* swiper.module.css */
.slider-container {
  width: 100%;
  max-width: 1200px; /* Optional: Adjust as needed */
  margin: 0 auto;
}

.slideImage {
  width: 100%;
  height: 363px;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SwiperSlider/sliderSwiper.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB,EAAE,+BAA+B;EAClD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/* swiper.module.css */\n.slider-container {\n  width: 100%;\n  max-width: 1200px; /* Optional: Adjust as needed */\n  margin: 0 auto;\n}\n\n.slideImage {\n  width: 100%;\n  height: 363px;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
